<form [formGroup]="form" (ngSubmit)="onSave()" class="formgrid grid">

  <div class="col-8">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Title</h3>
    <input pInputText formControlName="title" type="text" class="inputfield w-full"
      (input)="onTitleInput()"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('title')?.invalid && form.get('title')?.touched }"
      placeholder="What is a vigil?" />
  </div>

  <div class="col-4">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Category</h3>
    <p-dropdown formControlName="category" [options]="categories" styleClass="w-full" appendTo="body"></p-dropdown>
  </div>

  <div class="col-8">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Slug</h3>
    <input pInputText formControlName="slug" type="text" class="inputfield w-full"
      [readonly]="slugIsReadOnly"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('slug')?.invalid && form.get('slug')?.touched, 'surface-100': slugIsReadOnly }"
      placeholder="what-is-a-vigil" />
    <small class="block text-500 mt-1">
      Auto-generated from the title.
      <a class="cursor-pointer text-primary font-medium" (click)="toggleSlugEdit()">{{ slugIsReadOnly ? 'Edit manually' : 'Auto from title' }}</a>
    </small>
  </div>

  <div class="col-4">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Publish date</h3>
    <p-calendar formControlName="publishedAt" dateFormat="dd/mm/yy" styleClass="w-full" appendTo="body" [showIcon]="true"></p-calendar>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Excerpt <span class="text-500 text-sm font-normal">(SEO summary, ~155 chars)</span></h3>
    <textarea pInputTextarea formControlName="excerpt" rows="2" class="inputfield w-full"
      placeholder="A one- or two-sentence summary for search results and cards."></textarea>
  </div>

  <!-- ABOVE the body on purpose. The body textarea is 16 rows, so anything
       under it is off-screen when the modal opens — an author reasonably
       concludes there is no way to add an image at all. -->
  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Hero image</h3>
    <div class="flex align-items-center gap-3">
      <img *ngIf="heroPreview" [src]="heroPreview" alt="Hero preview" style="height: 48px; width: auto; border-radius: 6px;" />
      <span *ngIf="!heroPreview && heroFileId" class="text-500 text-sm">Hero attached</span>
      <button pButton pRipple type="button" [label]="heroFileId ? 'Replace hero' : 'Upload hero'" icon="pi pi-upload" class="p-button-outlined" (click)="uploadHero()"></button>
      <button *ngIf="heroFileId" pButton pRipple type="button" label="Remove" class="p-button-text p-button-danger" (click)="removeHero()"></button>
      <small class="text-500">Shown at the top of the article and on listing cards.</small>
    </div>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Body</h3>

    <app-markdown-editor
      formControlName="body"
      [heightRem]="26"
      imageBucketPrefix="blog-body"
      [imageAltFallback]="form.get('title')?.value || 'Article image'"
      placeholder="Write the article here. Use the buttons above for headings, bold, links, lists and images."
    ></app-markdown-editor>
    <small class="block mt-1 text-500">
      The preview button renders this exactly as picaluna.com will. Images
      upload straight into the article — site chrome isn't shown.
    </small>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Endorsed by</h3>
    <p-multiSelect
      [options]="arrangerOptions"
      [(ngModel)]="endorsedBy"
      [ngModelOptions]="{ standalone: true }"
      optionLabel="label"
      optionValue="value"
      placeholder="Arrangers who endorse this article"
      styleClass="w-full"
      appendTo="body"
      [filter]="true"
    ></p-multiSelect>
    <small class="block text-500 mt-1">Each endorsing arranger links to their profile on picaluna.com.</small>
  </div>

  <div class="col-12 flex align-items-center mt-3">
    <p-inputSwitch class="flex-initial" formControlName="published"></p-inputSwitch>
    <span class="ml-2 text-700">Published (live on picaluna.com — leave off to keep it a draft)</span>
  </div>

  <div class="col-12 flex justify-content-end gap-2 mt-3">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
    <button pButton pRipple type="submit" label="Save" icon="pi pi-check" [loading]="saving"></button>
  </div>

</form>
